import { render, staticRenderFns } from "./LimitedTimeAwardList.vue?vue&type=template&id=b5f2ac84&scoped=true&"
import script from "./LimitedTimeAwardList.vue?vue&type=script&lang=js&"
export * from "./LimitedTimeAwardList.vue?vue&type=script&lang=js&"
import style0 from "./LimitedTimeAwardList.vue?vue&type=style&index=0&id=b5f2ac84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f2ac84",
  null
  
)

export default component.exports